import { fork } from 'redux-saga/effects';

import { actions, selectors } from 'domain/portfolioList';
import { listNavigator } from 'sagas/common';
import filters from 'filters/portfolio';

export default function* navigator() {
  yield fork(listNavigator, { modelName: 'Portfolio', actions, selectors, filters } );
}
